import { render, staticRenderFns } from "./ProjectContPhone.vue?vue&type=template&id=27cfcc66&"
import script from "./ProjectContPhone.vue?vue&type=script&lang=js&"
export * from "./ProjectContPhone.vue?vue&type=script&lang=js&"
import style0 from "./ProjectContPhone.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports